$(document).ready(function() {
  // Hide all 'bill-of-right-block-content' elements except the first one
  $('.bill-of-right-block-content').not(':first').hide();

  $('.bill-of-right-block-area-main .bill-of-right-block-top').click(function() {
    // Check if the clicked block's content is not already visible
    if (!$(this).next('.bill-of-right-block-content').is(':visible')) {
      // Hide all 'bill-of-right-block-content' elements
      $('.bill-of-right-block-content').slideUp(400);
      // Remove 'is--active' class from all other '.bill-of-right-block-top' elements
      $('.bill-of-right-block-top').removeClass('is--active');
    }

    // Toggle 'is--active' class on the clicked block's top element
    $(this).toggleClass('is--active');

    // SlideToggle the content of the clicked block
    $(this).next('.bill-of-right-block-content').slideToggle(400);
  });

  // Trigger a click event on the first 'bill-of-right-block-top' to open it initially
  $('.bill-of-right-block-area-main .bill-of-right-block-top:first').trigger('click');
});



